import React from 'react'
import { HelpIcon } from '@nominex/dex-uikit'
import { SlTooltip } from '@shoelace-style/shoelace/dist/react'
import type SlTooltipElement from '@shoelace-style/shoelace/dist/components/tooltip/tooltip'

const QuestionHelper: React.FC<{ content: SlTooltipElement['content']; placement?: SlTooltipElement['placement'] }> = ({
  content,
  placement = 'top',
}) => (
  <SlTooltip content={content} placement={placement} hoist>
    <HelpIcon width="12px" height="12px" ml="4px" />
  </SlTooltip>
)

export default QuestionHelper
